@let viewOnly = !(data.canUpdate && (!this.data.scheduledEmail || this.data.scheduledEmail.isEnabled === false));
@let title =
    "SCHEDULED_EMAILS." +
    (viewOnly ? "readScheduledEmail" : data.scheduledEmail ? "editScheduledEmail" : "addScheduledEmail");
<cipo-dialog-header [title]="title" />
<mat-dialog-content>
    <form [formGroup]="form" class="p-t" fxLayout="column" fxLayoutGap="16px">
        <div fxLayout.lt-md="column" fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="space-between">
            <cipo-text fxFlex="49" fxFlex.lt-md="100" [control]="form.controls.jobName" />
            <cipo-text fxFlex="49" fxFlex.lt-md="100" [control]="form.controls.description" />
        </div>
        <div fxLayout.lt-md="column" fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="space-between">
            <cipo-select fxFlex="32" fxFlex.lt-md="100" [control]="form.controls.scheduleFrequency" />
            <cipo-date-time fxFlex="32" fxFlex.lt-md="100" [control]="form.controls.startDate" />
            <cipo-date-time fxFlex="32" fxFlex.lt-md="100" [control]="form.controls.timeOfDay" />
        </div>
        <div fxLayout.lt-md="column" fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="space-between">
            <cipo-select fxFlex="32" fxFlex.lt-md="100" [control]="form.controls.moduleIds" [options]="modules()" />
            <cipo-select fxFlex="32" fxFlex.lt-md="100" [control]="form.controls.sendTo" />
            <cipo-select
                fxFlex="32"
                fxFlex.lt-md="100"
                [control]="form.controls.additionalRecipients"
                [options]="additionalRoles()" />
        </div>
        <div class="m-b">
            <h3 class="m-a-0">{{ "SCHEDULED_EMAILS.summary.title" | translate }}</h3>
            <div class="cipo-bg--primary-100 p-a-md cipo--border-radius--xs">
                @if (isManual()) {
                    <p [innerHTML]="'SCHEDULED_EMAILS.summary.manual' | translate"></p>
                } @else {
                    <p>
                        {{ "SCHEDULED_EMAILS.summary.prefix" | translate }}
                        @if (weekDay() !== undefined) {
                            <span
                                translate="SCHEDULED_EMAILS.summary.weekly"
                                [translateParams]="{
                                    weekDay: 'WEEK_DAYS.' + WEEK_DAYS[weekDay()] | translate,
                                }"></span>
                        } @else {
                            <span>{{ "SCHEDULED_EMAILS.summary.daily" | translate }}</span>
                        }
                        <span
                            translate="SCHEDULED_EMAILS.summary.time"
                            [translateParams]="{
                                time: ($any(form.value.timeOfDay) | itvTime),
                            }"></span>
                    </p>
                }
                <p [innerHTML]="'SCHEDULED_EMAILS.summary.rule1' | translate: { percent: percentNearOverdue() }"></p>
            </div>
        </div>

        @if (tributeOptionsLoaded()) {
            <app-froala
                class="cipo--display--block m-b"
                [control]="form.controls.subject"
                [froalaoptions]="froalaOptionsSubject"
                [tributeoptions]="tributeOptions()"
                [required]="true"
                label="SCHEDULED_EMAILS.emailSubject"
                [editmode]="!isDisabled() && !viewOnly" />
            <app-froala
                [control]="form.controls.emailBody"
                [froalaoptions]="FroalaConfig.basic"
                [tributeoptions]="tributeOptions()"
                [required]="true"
                label="SCHEDULED_EMAILS.emailContent"
                [editmode]="!isDisabled() && !viewOnly" />
        }

        @if (data.scheduledEmail && data.scheduledEmail.lastRunOn) {
            <div class="m-t">
                <h3 class="m-a-0">{{ "SCHEDULED_EMAILS.lastRun" | translate }}</h3>
                <div class="cipo-bg--primary-100 p-a-md cipo--border-radius--xs">
                    <p>Date: {{ data.scheduledEmail.lastRunOn | itvDateTime }}</p>
                    @if (data.scheduledEmail.lastRunError) {
                        <p class="m-t cipo-text--warn-900">{{ data.scheduledEmail.lastRunError }}</p>
                    }
                </div>
            </div>
        }
    </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>{{ "actions.close" | translate }}</button>
    @if (data.canUpdate && (!this.data.scheduledEmail || this.data.scheduledEmail.isEnabled === false)) {
        <button mat-flat-button color="primary" (click)="saveChanges()" [disabled]="!form.valid || !form.dirty">
            {{ "actions." + (data.scheduledEmail ? "update" : "save") | translate }}
        </button>
        @if (!data.scheduledEmail && isManual()) {
            <button mat-flat-button color="primary" (click)="saveChanges(true)" [disabled]="!form.valid">
                {{ "actions.sendNowSave" | translate }}
            </button>
        }
    }
</mat-dialog-actions>
